export default "__VITE_ASSET__51eea839__"